import { ASSETS_API_URL } from "config/api";
import { showApiError, showFormError } from "config/apiToast";
import { getApiErrorMessages } from "config/apiErrors";
import React, { useState, useEffect } from "react";
import "./dashboard.scss";
import Dropdown from 'react-bootstrap/Dropdown';
// import { Link } from "react-router-dom";
import axios from "axios";
// import { useParams } from "react-router-dom";
import { useLocation, useHistory, useParams } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { MARKET_FIELDS, buildMarketFormData, normalizeSymbolInput, trimDecimal, validateMarketForm } from "./marketFields";
import { NETWORK_FIELDS, buildNetworkPayload, validateNetworkForm } from "./networkFields";
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const Marketdetails = () => {
  const history = useHistory();
  const query = useQuery();
  const ids = query.get('ids');
  const [marketName, setMarketName] = useState("");
  const [marketBase, setMarketBase] = useState("");
  const [decimals, setDecimals] = useState("");
  const [loadError, setLoadError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [coinID, setCoinID] = useState("");
  const [id, setid] = useState("");
  const [dailyWithdrawLimit, setDailyWithdrawLimit] = useState("");
  const [essential, setEssential] = useState(false);
  const [listed, setListed] = useState(false);
  const [available, setAvailable] = useState(false);
  const [isToken, setIsToken] = useState(false);
  // console.log("tokern_++++++++++", isToken)
  const [marketIcon, setMarketIcon] = useState(null);
  const [preview, setPreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [tasks, setTasks] = useState([]);
  const [networks, setNetworks] = useState([]);
  const [details, setdetails] = useState([]);
  const [errorss, setErrorss] = useState({});
  const [Chianname, setChianname] = useState("");
  const [chainid, setChainID] = useState("");
  const [minConfirmations, setMinConfirmations] = useState("");
  const [minDeposit, setMinDeposit] = useState("");
  const [minWithdraw, setMinWithdraw] = useState("");
  const [contractAddress, setContractAddress] = useState("");
  const [maxWithdraw, setMaxWithdraw] = useState("");
  const [marketid, setMarketID] = useState("");
  const [networkId, setNetworkId] = useState(null);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setChianname("");
    setChainID("");
    setMinConfirmations("");
    setMinDeposit("");
    setMinWithdraw("");
    setMaxWithdraw("");
    setContractAddress("");
    // setMarketID("");
    setIsToken(false);
    setErrorss({}); // Reset any validation errors
    setIsEditMode(false); // Reset the mode to default (add mode)
  }
  const handleShow = () => setShow(true);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: undefined,
    }));

    switch (id) {
      case "marketName":
        setMarketName(value);
        break;
      case "marketBase":
        // The API only accepts lowercase letters and numbers.
        setMarketBase(normalizeSymbolInput(value));
        break;
      case "decimals":
        setDecimals(value);
        break;
      case "dailyWithdrawLimit":
        setDailyWithdrawLimit(value);
        break;
      default:
        break;
    }
  };

  const handleInputChangess = (e) => {
    const { id, value } = e.target;
    // Clear the error for the current input field
    setErrorss((prevErrorss) => ({
      ...prevErrorss,
      [id]: undefined, // Remove the error message for the current input field
    }));

    // Handle setting state based on input ID
    switch (id) {

      case "minConfirmations":
        setMinConfirmations(value);
        break;
      case "minDeposit":
        setMinDeposit(value);
        break;
      case "minWithdraw":
        setMinWithdraw(value);
        break;
      case "maxWithdraw":
        setMaxWithdraw(value);
        break;
      case "contractAddress":
        setContractAddress(value);
        break;

      default:
        break;
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setErrors((prevErrors) => ({
      ...prevErrors,
      marketIcon: undefined,
    }));

    if (file) {
      setMarketIcon(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (submitting) return;

    let tok = localStorage.getItem("accessTokenDash");

    const form = {
      name: marketName,
      symbol: marketBase,
      decimals,
      dailyWithdrawLimit,
      isEssential: essential,
      isListed: listed,
      isAvailable: available,
      icon: marketIcon,
      // Editing keeps the current image when no new file is chosen.
      requireIcon: !ids,
    };

    const formErrors = validateMarketForm(form);
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the highlighted fields", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setSubmitting(true);
    var config = {
      method: ids ? "PATCH" : "POST",
      url: ids ? `${ASSETS_API_URL}/markets/${ids}` : `${ASSETS_API_URL}/markets`,
      headers: {
        authorization: `Bearer ` + tok
      },
      data: buildMarketFormData(form),
    };
    axios(config)
      .then(function () {
        toast.success(ids ? "Market Edit Successfully" : "Market Added Successfully", {
          position: "top-right",
          autoClose: 3000,
        });
        history.push("market");
      })
      .catch(function (error) {
        const messages = getApiErrorMessages(error);
        toast.error(
          <div>{messages.map((message, index) => <div key={index}>{message}</div>)}</div>,
          { position: "top-right", autoClose: 6000 }
        );
        setSubmitting(false);
      });
  };

  const getData = async () => {
    const tok = localStorage.getItem("accessTokenDash");
    setTasks([]);
    var config = {
      method: "get",
      url: `${ASSETS_API_URL}/chains?page=1&limit=20`,
      headers: {
        authorization: `Bearer ${tok}`
      },
    };

    axios(config)
      .then(function (response) {
        setTasks(response?.data?.data);
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        showApiError(error);
      });
  };

  const getDataMarket = async () => {
    const tok = localStorage.getItem("accessTokenDash");
    setLoadError("");
    var config = {
      method: "get",
      url: `${ASSETS_API_URL}/markets/${ids}`,
      headers: {
        authorization: `Bearer ${tok}`
      },
    };

    axios(config)
      .then(function (response) {
        const data = response?.data?.data;
        if (!data) {
          setLoadError("Market not found.");
          return;
        }
        setdetails(data);
        setMarketName(data.name);
        setMarketBase(data.symbol);
        setMarketID(data?.id)
        setCoinID(data.coinId);
        setid(data.chainId);
        setDecimals(data.decimals === null || data.decimals === undefined ? "" : String(data.decimals));
        // Amounts come back with 18 decimal places, e.g. "1000000.000000000000000000".
        setDailyWithdrawLimit(trimDecimal(data.dailyWithdrawLimit));
        setEssential(data.isEssential);
        setListed(data.isListed);
        setAvailable(data.isAvailable);
        setIsToken(data.isToken);
        setPreview(data.icon);
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        setLoadError(getApiErrorMessages(error).join(" "));
      });
  };


  const getDataMarketNetworks = async () => {
    const tok = localStorage.getItem("accessTokenDash");
    var config = {
      method: "get",
      url: `${ASSETS_API_URL}/networks?marketId=${marketid}`,
      headers: {
        authorization: `Bearer ${tok}`
      },
    };

    axios(config)
      .then(function (response) {
        setNetworks(response?.data?.data);
        // setActiveNetwork(response?.data?.data?.isActive)
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        showApiError(error);
      });
  };

  useEffect(() => {
    if (marketid) {
      getDataMarketNetworks();
    }
  }, [marketid]);

  useEffect(() => {
    getData();
  }, []);


  useEffect(() => {
    if (ids) {
      getDataMarket();
    }
  }, [ids]);

  const handleCategoryChangeS = (item) => {
    setErrorss((prevErrorss) => ({
      ...prevErrorss,
      chainid: undefined, // Remove the error message for the market icon
    }));
    setChainID(item?.id)
    setChianname(item);
  };

  const handleSubmitNetwork = async () => {
    console.log("", minDeposit)
    console.log("", minConfirmations)
    console.log("", minWithdraw)
    console.log("", maxWithdraw)
    console.log("", contractAddress)
    console.log("", isToken)
    console.log("", marketid.toString())
    console.log("", chainid.toString())

    let tok = localStorage.getItem("accessTokenDash");

    const networkForm = {
      marketId: marketid,
      chainId: chainid,
      minConfirmations,
      minDeposit,
      minWithdraw,
      maxWithdraw,
      contractAddress,
      isToken,
    };
    const formErrorss = validateNetworkForm(networkForm);

    if (Object.keys(formErrorss).length > 0) {
      setErrorss(formErrorss);
      showFormError();
      return;
    }
    // Market and chain cannot be changed once the network exists.
    const requestBody = buildNetworkPayload({ ...networkForm, includeMarketAndChain: !isEditMode });

    var config = {
      method: isEditMode ? "PATCH" : "POST", // Use PUT for edit, POST for add
      url: `${ASSETS_API_URL}/networks${isEditMode ? `/${networkId}` : ""}`,
      headers: {
        authorization: `Bearer ` + tok
      },
      data: requestBody,
    };
    axios(config)
      .then(function (response) {
        if(isEditMode){
          toast
          .success("Network Edit Successfully", {
              position: "top-right",
              autoClose: 3000,
          })
        }
        else{
          toast
          .success("Network Added Successfully", {
              position: "top-right",
              autoClose: 3000,
          })
        }
        setMinConfirmations("");
        setMinDeposit("");
        setMinWithdraw("");
        setMaxWithdraw("");
        setChianname("")
        setChainID("")
        // setMarketID("")
        handleClose()
        getDataMarketNetworks()
      })
      .catch(function (error) {
        showApiError(error);
      });
  };

  const activeDeactive = async (item) => {
    if (item?.isActive === false) {
      const networkactive = true
      let tok = localStorage.getItem("accessTokenDash");
      const requestBody = {
        isActive: networkactive,
      };
      var config = {
        method: "PATCH",
        url: `${ASSETS_API_URL}/networks/${item?.id}`,
        headers: {
          authorization: `Bearer ${tok}`
        },
        data: requestBody,
      };
      axios(config)
        .then(function (response) {
          toast
          .success("Network Status Changed Successfully", {
              position: "top-right",
              autoClose: 3000,
          })
          getDataMarketNetworks();
        })
        .catch(function (error) {
          showApiError(error);
        });
    }
    else {
      const networkactive = false
      let tok = localStorage.getItem("accessTokenDash");
      const requestBody = {
        isActive: networkactive,
      };
      var config = {
        method: "PATCH",
        url: `${ASSETS_API_URL}/networks/${item?.id}`,
        headers: {
          authorization: `Bearer ${tok}`
        },
        data: requestBody,
      };
      axios(config)
        .then(function (response) {
          getDataMarketNetworks();
        })
        .catch(function (error) {
          showApiError(error);
        });
    }
  };

  const deleteNetwork = async (item) => {
    // const networkactive = true
    let tok = localStorage.getItem("accessTokenDash");
    // const requestBody = {
    //   isActive: networkactive,
    // };
    var config = {
      method: "DELETE",
      url: `${ASSETS_API_URL}/networks/${item?.id}`,
      headers: {
        authorization: `Bearer ${tok}`
      },
      // data: requestBody,
    };
    axios(config)
      .then(function (response) {
        getDataMarketNetworks();
      })
      .catch(function (error) {
        showApiError(error);
      });

  };


  const handleEditNetwork = async (networkId) => {
    setIsEditMode(true); // Set the modal to Edit mode
    setNetworkId(networkId);
    try {
      let tok = localStorage.getItem("accessTokenDash");
      const response = await axios.get(`${ASSETS_API_URL}/networks/${networkId}`, {
        headers: {
          authorization: `Bearer ` + tok
        }
      });

      const networkData = response.data.data;
      // Find the chain from the fetched tasks
      const selectedChain = tasks.find((chain) => chain.id === networkData.chainId);

      // Populate the states with fetched data
      setChianname({ name: selectedChain?.name, standard: selectedChain?.standard });
      setChainID(networkData.chainId);
      setMinConfirmations(networkData.minConfirmations);
      setMinDeposit(networkData.minDeposit);
      setMinWithdraw(networkData.minWithdraw);
      setMaxWithdraw(networkData.maxWithdraw);
      setContractAddress(networkData.contractAddress);
      setMarketID(networkData.marketId);
      setIsToken(networkData.isToken);

      // Open the modal after setting the state
      setShow(true);
    } catch (error) {
      console.error("Failed to fetch network data", error);
      // Handle the error accordingly
    }
  };
  return (
    <>
      <img className='elipse img-fluid' src='/assets/main-assets/Ellipse.png' alt="ellipse" />
      <div className="content">
        <div className="tokenicon">
          <p className="para1">Market Icon</p>
          <div className="headparent">
            <div className='maininput'>
              <label htmlFor='upload'>
                <div className='wrapper'>

                  {preview ?
                    (
                      <img src={preview} alt="Market Icon Preview" className="preview shcvsdghvdhc" />
                    )     
                    :
                    (
                      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="47" viewBox="0 0 46 47" fill="none" className='cursorrrr'>
                        <path d="M17.2501 21.1042C14.3367 21.1042 11.9792 18.7467 11.9792 15.8333C11.9792 12.92 14.3367 10.5625 17.2501 10.5625C20.1634 10.5625 22.5209 12.92 22.5209 15.8333C22.5209 18.7467 20.1634 21.1042 17.2501 21.1042ZM17.2501 13.4375C15.9276 13.4375 14.8542 14.5108 14.8542 15.8333C14.8542 17.1558 15.9276 18.2292 17.2501 18.2292C18.5726 18.2292 19.6459 17.1558 19.6459 15.8333C19.6459 14.5108 18.5726 13.4375 17.2501 13.4375Z" fill="#232323" />
                        <path d="M28.7499 44.1041H17.2499C6.84242 44.1041 2.39575 39.6574 2.39575 29.2499V17.7499C2.39575 7.34242 6.84242 2.89575 17.2499 2.89575H24.9166C25.7024 2.89575 26.3541 3.54742 26.3541 4.33325C26.3541 5.11909 25.7024 5.77075 24.9166 5.77075H17.2499C8.41408 5.77075 5.27075 8.91408 5.27075 17.7499V29.2499C5.27075 38.0858 8.41408 41.2291 17.2499 41.2291H28.7499C37.5858 41.2291 40.7291 38.0858 40.7291 29.2499V19.6666C40.7291 18.8808 41.3808 18.2291 42.1666 18.2291C42.9524 18.2291 43.6041 18.8808 43.6041 19.6666V29.2499C43.6041 39.6574 39.1574 44.1041 28.7499 44.1041Z" fill="#232323" />
                        <path d="M40.7292 11.5208H30.1875C29.4017 11.5208 28.75 10.8691 28.75 10.0833C28.75 9.29742 29.4017 8.64575 30.1875 8.64575H40.7292C41.515 8.64575 42.1667 9.29742 42.1667 10.0833C42.1667 10.8691 41.515 11.5208 40.7292 11.5208Z" fill="#232323" />
                        <path d="M35.4583 16.7917C34.6724 16.7917 34.0208 16.14 34.0208 15.3542V4.8125C34.0208 4.02667 34.6724 3.375 35.4583 3.375C36.2441 3.375 36.8958 4.02667 36.8958 4.8125V15.3542C36.8958 16.14 36.2441 16.7917 35.4583 16.7917Z" fill="#232323" />
                        <path d="M5.11741 38.2582C4.65741 38.2582 4.19741 38.0282 3.92908 37.6257C3.48824 36.9741 3.66074 36.0732 4.31241 35.6324L13.7616 29.2882C15.8316 27.9082 18.6874 28.0616 20.5657 29.6524L21.1982 30.2082C22.1566 31.0324 23.7857 31.0324 24.7249 30.2082L32.6982 23.3657C34.7491 21.6216 37.9307 21.6216 39.9816 23.3657L43.1057 26.0491C43.6999 26.5666 43.7766 27.4674 43.2591 28.0807C42.7416 28.6749 41.8407 28.7516 41.2274 28.2341L38.1032 25.5507C37.1449 24.7266 35.5157 24.7266 34.5766 25.5507L26.6032 32.3932C24.5716 34.1374 21.3707 34.1374 19.3199 32.3932L18.6874 31.8374C17.8057 31.0899 16.3491 31.0132 15.3716 31.6841L5.94158 38.0282C5.67324 38.1816 5.38574 38.2582 5.11741 38.2582Z" fill="#232323" />
                      </svg>
                    )
                  }

                  <p className='gray'>  Add Market Icon Image
                    <br></br>
                    Supports: JPG, JPEG, PNG</p>
                  <input type='file' id='upload' accept="image/png, image/jpeg, image/jpg" className='d-none' onChange={handleImageChange} />
                  {errors.marketIcon && <p className="error">{errors.marketIcon}</p>}
                </div>
              </label>
            </div>
          </div>
          <div className="mainparent2">
            {loadError && <p className="error">{loadError}</p>}
            <p className="inputtextttt">{MARKET_FIELDS.name.label}</p>
            <input type="text" placeholder={MARKET_FIELDS.name.placeholder} className="inputttclass" id="marketName" value={marketName} onChange={handleInputChange} />
            {errors.marketName && <p className="error">{errors.marketName}</p>}

            <p className="inputtextttt">{MARKET_FIELDS.symbol.label}</p>
            <input type="text" placeholder={MARKET_FIELDS.symbol.placeholder} className="inputttclass" id="marketBase" value={marketBase} onChange={handleInputChange} />
            {errors.marketBase
              ? <p className="error">{errors.marketBase}</p>
              : <p className="pairfieldhint">{MARKET_FIELDS.symbol.hint}</p>}
            {errors.chain && <p className="error">{errors.chain}</p>}

            <p className="inputtextttt">{MARKET_FIELDS.decimals.label}</p>
            <input type="text" inputMode="numeric" placeholder={MARKET_FIELDS.decimals.placeholder} className="inputttclass" id="decimals" value={decimals} onChange={handleInputChange} />
            {errors.decimals
              ? <p className="error">{errors.decimals}</p>
              : <p className="pairfieldhint">{MARKET_FIELDS.decimals.hint}</p>}

            <p className="inputtextttt">{MARKET_FIELDS.dailyWithdrawLimit.label}</p>
            <input type="text" inputMode="decimal" placeholder={MARKET_FIELDS.dailyWithdrawLimit.placeholder} className="inputttclass" id="dailyWithdrawLimit" value={dailyWithdrawLimit} onChange={handleInputChange} />
            {errors.dailyWithdrawLimit
              ? <p className="error">{errors.dailyWithdrawLimit}</p>
              : <p className="pairfieldhint">{MARKET_FIELDS.dailyWithdrawLimit.hint}</p>}
            <div className="networkbox">
              <div className="innertext">
                <p>Networks</p>
                <a onClick={handleShow}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 10H15" stroke="#D5FF2F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M10 15V5" stroke="#D5FF2F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg> Add</a>
              </div>
              <div className="mainacc">
                <Accordion defaultActiveKey="0">
                  {networks?.map((elem, index) => (
                    <Accordion.Item eventKey={index}>
                      <Accordion.Header>
                        <div className="mainhead">
                          <p><img src={elem?.chain?.logo} alt="img" className="img-fluid knknknjknjnjn" />{elem?.chain?.name}</p>
                          <div className="sdffsfsfsdds forwidthsss">
                            <p className="availtab">Is Active</p>
                            <label className="switch">
                              <input type="checkbox" checked={elem?.isActive} onChange={() => activeDeactive(elem)} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                          <div className="deleterow">
                            <i onClick={() => handleEditNetwork(elem?.id)} class="far fa-edit sdvgfrbedsvdsveb"  ></i>
                            {/* <img onClick={() => deleteNetwork(elem)} src="\assets\Trash_Full.svg" alt="img" className="img-fluid sdvgfrbedsvdsveb" /> */}
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="parentboday">
                          <div className="inner">
                            <p>Max Withdraw</p>
                            <h6>{elem?.maxWithdraw}</h6>
                          </div>
                          <div className="inner">
                            <p>Min Withdraw</p>
                            <h6>{elem?.minWithdraw}</h6>
                          </div>
                          <div className="inner">
                            <p>Min Deposit</p>
                            <h6>{elem?.minDeposit}</h6>
                          </div>
                          <div className="inner">
                            <p>Min Confirmations</p>
                            <h6>{elem?.minConfirmations}</h6>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
            <div className="listedhead">
              <p className="availtab">Essential</p>
              <label className="switch">
                <input type="checkbox" checked={essential} onChange={() => setEssential(!essential)} />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="listedhead">
              <p className="availtab">Listed</p>
              <label className="switch">
                <input type="checkbox" checked={listed} onChange={() => setListed(!listed)} />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="listedhead">
              <p className="availtab">Available</p>
              <label className="switch">
                <input type="checkbox" checked={available} onChange={() => setAvailable(!available)} />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="mainbuttdiv">
              <button className="buttt1 w-100" onClick={handleSubmit} disabled={submitting}>
                {submitting ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal className="mainnetworkmodal jhegfehbfverhbferhybf" show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>{isEditMode ? "Edit Network" : "Add Network"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mainbodaycontent">
            <p>Market</p>
            <input value={`${marketName} (${marketBase.toLocaleUpperCase()})`} type="text" placeholder="Selected Market" />
            <p>Chain</p>
            <div className="drop">
              <div className='shghsdhsdhgj drop'>
                <div className="dropdown buttons-list-all">
                  <button className={isEditMode ? "eferfewfefeferferf" : ""} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <p className="dvhjbdhjefv">{Chianname?.name ? Chianname?.name : 'Select Chain'} {Chianname ? `(${Chianname?.standard})` : ""} </p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M9.29226 0.5H5.21637H1.5461C0.918037 0.5 0.604004 1.25891 1.04888 1.70379L4.43783 5.09274C4.98084 5.63575 5.86406 5.63575 6.40708 5.09274L7.69592 3.80389L9.79602 1.70379C10.2344 1.25891 9.92033 0.5 9.29226 0.5Z" fill="white" />
                    </svg>
                  </button>
                  <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {tasks?.map((elem, index) => (
                      <a key={index} className="dropdown-item" onClick={() => handleCategoryChangeS(elem)}><p>{elem.name} {`(${elem.standard})`}</p></a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {errorss.chainid && <p className="error">{errorss.chainid}</p>}

            <p className="inputtextttt">Min Confirmations</p>
            <input type="number" placeholder="Min Confirmations" className="inputttclass" id="minConfirmations" value={minConfirmations} onChange={handleInputChangess} />
            {errorss.minConfirmations && <p className="error">{errorss.minConfirmations}</p>}
            <p className="inputtextttt">Min Deposit</p>
            <input type="number" placeholder="Min Deposit (e.g. 10)" className="inputttclass" id="minDeposit" value={minDeposit} onChange={handleInputChangess} />
            {errorss.minDeposit && <p className="error">{errorss.minDeposit}</p>}
            <p className="inputtextttt">Min Withdraw</p>
            <input type="number" placeholder="Min Withdraw (e.g. 1000)" className="inputttclass" id="minWithdraw" value={minWithdraw} onChange={handleInputChangess} />
            {errorss.minWithdraw && <p className="error">{errorss.minWithdraw}</p>}
            <p className="inputtextttt">{NETWORK_FIELDS.maxWithdraw.label}</p>
            <input type="text" inputMode="decimal" placeholder={NETWORK_FIELDS.maxWithdraw.placeholder} className="inputttclass" id="maxWithdraw" value={maxWithdraw} onChange={handleInputChangess} />
            {errorss.maxWithdraw
              ? <p className="error">{errorss.maxWithdraw}</p>
              : <p className="pairfieldhint">{NETWORK_FIELDS.maxWithdraw.hint}</p>}
            <div className="listedhead">
              <p className="availtab">Is Token</p>
              <label className="switch">
                <input type="checkbox" className="eferfewfefeferferf" checked={isToken} onChange={() => setIsToken(!isToken)} />
                <span className="slider round"></span>
              </label>
            </div>
            {isToken === true &&
              (
                <>
                  <p>Contract Address</p>
                  <input type="text" className="" placeholder="Contract Address" id="contractAddress" value={contractAddress} onChange={handleInputChangess} />

                </>
              )

            }
            {errorss.contractAddress && <p className="error">{errorss.contractAddress}</p>}
            <div className='addmarketbuttonsss'>
              <button type="button" onClick={handleSubmitNetwork} className="w-100">  {isEditMode ? "Update Network" : "Add Network"}</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Marketdetails;
